import React from 'react';
import ContactForm from '../../Components/Forms/ContactForm';

const Contact = () => {
  return <ContactForm />;
};

export default Contact;
